import type { ReactNode } from 'react';
import EstudioFeedback from '@/components/estudio-feedback/EstudioFeedback';

// Capa por encima de las rutas. AppLayout es el shell con sidebar;
// este solo monta cromo que debe vivir en TODA la app (login, /subir,
// /proyectos, dashboard). El FAB se apaga solo si el gate no deja pasar.

export default function RootLayout({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <EstudioFeedback />
    </>
  );
}
